import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
/**
 * SEM stands for Search Engine Marketing
 * @returns true if the utm_medium is cpc
 */ export var isComingFromSEM = function(location) {
    var _location_search;
    var utmMedium = parseQueryParams((_location_search = location === null || location === void 0 ? void 0 : location.search) !== null && _location_search !== void 0 ? _location_search : "").get("utm_medium");
    return utmMedium === "cpc";
};
export var isSemTraffic = function(searchParams) {
    return searchParams.utm_medium === "cpc";
};
